import React from "react";
import PropTypes from "prop-types";
import Alert, { AlertState } from "../../../../elements/Alert";
import { VerticalSpacing } from "../../../../elements";
import { VerticalSpacingSizes } from "../../../../core/types";
import getClassNameFactory from "../../../../utilities/classNames";
import ChevronDownIcon from "@dcl/icons/esm/ui/chevron-down";
var SelectControl = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var defaultValue = _ref.defaultValue,
      disabled = _ref.disabled,
      id = _ref.id,
      labelText = _ref.labelText,
      renderLabel = _ref.renderLabel,
      name = _ref.name,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      options = _ref.options,
      placeholder = _ref.placeholder,
      placeholderText = _ref.placeholderText,
      required = _ref.required,
      value = _ref.value,
      ariaRequired = _ref.ariaRequired,
      ariaInvalid = _ref.ariaInvalid,
      isError = _ref.isError,
      errorMessage = _ref.errorMessage,
      _ref$optionalText = _ref.optionalText,
      optionalText = _ref$optionalText === void 0 ? "(Optional)" : _ref$optionalText,
      isExpanded = _ref.isExpanded,
      onKeyPress = _ref.onKeyPress,
      onDropdownClick = _ref.onDropdownClick,
      describedby = _ref.describedby;
  var getClassName = getClassNameFactory(SelectControl.displayName);

  var handleDropdownClick = function handleDropdownClick(event) {
    return onDropdownClick === null || onDropdownClick === void 0 ? void 0 : onDropdownClick(event);
  };

  var handleKeyPress = function handleKeyPress(event) {
    return onKeyPress === null || onKeyPress === void 0 ? void 0 : onKeyPress(event);
  };

  var determineConsentPath = function determineConsentPath(consentParameters) {
    var countryCode = consentParameters.countryCode,
        contentPath = consentParameters.contentPath,
        targetLang = consentParameters.targetLang,
        supportedCountries = consentParameters.supportedCountries,
        notSupportedCountries = consentParameters.notSupportedCountries;

    if (supportedCountries.includes(countryCode)) {
      return "".concat(contentPath, "/").concat(countryCode, "/").concat(targetLang);
    } else if (notSupportedCountries.includes(countryCode)) {
      return "".concat(contentPath, "/").concat(countryCode, "/master");
    }

    return "".concat(contentPath, "/master/").concat(targetLang);
  };

  var fetchConsentText = function fetchConsentText(domain, path, container) {
    fetch("".concat(domain).concat(path, ".nocloudconfigs.atoffer.html")).then(function (response) {
      return response.text();
    }).then(function (html) {
      container.innerHTML = html;
    })["catch"](function (error) {
      // eslint-disable-next-line no-console
      console.error("Error fetching consent text:", error);
      container.innerHTML = "";
    });
  };

  var consentCopyText = document.querySelector("input[name='consent-copy-form']");

  var addConsentText = function addConsentText(countryCode, domain) {
    try {
      // Get attributes from consentCopyText
      var contentPath = consentCopyText.getAttribute("consent-path");
      var targetLang = consentCopyText === null || consentCopyText === void 0 ? void 0 : consentCopyText.getAttribute("lang").toLowerCase();
      var supportedCountries = (consentCopyText.getAttribute("countries-supported") || "").split(",").map(function (country) {
        return country.trim();
      }).filter(function (country) {
        return country.length > 0;
      });
      var notSupportedCountries = (consentCopyText.getAttribute("countries-not-supported") || "").split(",").map(function (country) {
        return country.trim();
      }).filter(function (country) {
        return country.length > 0;
      }); // Create container to hold the consent text

      var consentCopyTextField = consentCopyText.closest(".hidden");
      var consentTextContainerId = "consent-text-container";
      var consentTextContainer = document.getElementById(consentTextContainerId);

      if (!consentTextContainer) {
        consentTextContainer = document.createElement("div");
        consentTextContainer.id = consentTextContainerId;
        consentCopyTextField.after(consentTextContainer);
      }

      var consentParameters = {
        countryCode: countryCode,
        contentPath: contentPath,
        targetLang: targetLang,
        supportedCountries: supportedCountries,
        notSupportedCountries: notSupportedCountries
      };
      var consentVariantPath = determineConsentPath(consentParameters);
      fetchConsentText(domain, consentVariantPath, consentTextContainer);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error in addConsentText:", error);
    }
  };

  var onChangeHandler = function onChangeHandler(e) {
    onChange(e);

    if (consentCopyText) {
      addConsentText(e.target.value.toLowerCase(), consentCopyText, window.location.origin);
    }
  };
  /* eslint-disable jsx-a11y/label-has-for */


  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement("label", {
    className: getClassName({
      descendantName: "label"
    }),
    htmlFor: id
  }, renderLabel ? renderLabel() : /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "labelText"
    })
  }, labelText, " ", !required && !ariaRequired && /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "optional"
    })
  }, optionalText)), /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "input"
    })
  }, /*#__PURE__*/React.createElement("select", {
    className: getClassName({
      descendantName: "select"
    }),
    defaultValue: defaultValue,
    disabled: disabled,
    id: id,
    name: name,
    onBlur: onBlur,
    onChange: onChangeHandler,
    onClick: handleDropdownClick,
    onKeyPress: handleKeyPress,
    required: required,
    value: value,
    ref: ref,
    "aria-label": labelText,
    "aria-expanded": isExpanded,
    "aria-invalid": ariaInvalid,
    "aria-required": ariaRequired,
    "aria-describedby": describedby,
    "aria-labelledby": describedby
  }, placeholder && /*#__PURE__*/React.createElement("option", {
    className: getClassName({
      descendantName: "option"
    }),
    value: ""
  }, placeholderText), options.map(function (option) {
    return /*#__PURE__*/React.createElement("option", {
      className: getClassName({
        descendantName: "option"
      }),
      key: option.value,
      value: option.value
    }, option.label);
  })), /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "arrow"
    })
  }, /*#__PURE__*/React.createElement(ChevronDownIcon, {
    width: 24
  })))), isError && /*#__PURE__*/React.createElement(VerticalSpacing, {
    size: VerticalSpacingSizes.XS
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Alert, {
    alertState: AlertState.FAILURE,
    id: describedby
  }, errorMessage))));
});
/* eslint-disable max-len */

SelectControl.propTypes = {
  /**
   * Initialize <select> with a value
   */
  defaultValue: PropTypes.string,

  /**
   * Disable the <select>
   */
  disabled: PropTypes.bool,

  /**
   * Id attribute for <select> (and <label> `for` atrribute)
   */
  id: PropTypes.string.isRequired,

  /**
   * Text for <label>
   */
  labelText: PropTypes.string,

  /**
   * Name attribute for <select>, required for serialisation
   */
  name: PropTypes.string.isRequired,

  /**
   * Listen for blur on the <select>.
   */
  onBlur: PropTypes.func,

  /**
   * Listen for changes on the <select>
   *
   * N.B. onChange should only be used for storing the value. Any action related to the value of the <select> should be handled onBlur. See https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-onchange.md
   */
  onChange: PropTypes.func,

  /**
   * Array of objects with `value` and `label` properties
   */
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })),

  /**
   * Show a placeholder <option>
   */
  placeholder: PropTypes.bool,

  /**
   * Text for placeholder <option>
   */
  placeholderText: PropTypes.string,

  /**
   * Set <select> to be required
   */
  required: PropTypes.bool,

  /**
   * Explicitly set the value of the <select>. Will switch to controlled mode
   */
  value: PropTypes.string,

  /**
   * Provided reference for <select> element
   */
  ref: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]),

  /**
   * An alternative to set <select> to be required
   */
  ariaRequired: PropTypes.bool,

  /**
   * Indicates validity of the value
   */
  ariaInvalid: PropTypes.bool,

  /**
   * render custom label
   */
  renderLabel: PropTypes.func,

  /**
   * render custom optionalText
   */
  optionalText: PropTypes.string,
  isError: PropTypes.bool,
  errorMessage: PropTypes.string,
  describedby: PropTypes.string,
  isExpanded: PropTypes.bool,
  onDropdownClick: PropTypes.func,
  onKeyPress: PropTypes.func
};
/* eslint-enable max-len */

SelectControl.defaultProps = {
  placeholder: true,
  placeholderText: "Select…",
  ariaRequired: false,
  ariaInvalid: false,
  isError: false
};
SelectControl.displayName = "Form.SelectControl";
export default SelectControl;